import { i18n } from "services/i18nService";

import { SUB_COMPONENT } from "views/Reports/reportConstants";

export const ExportProcessTransactions = {
  userHasSufficientPrivilege: () => true,
  planIncludesReport: (_, pro) => pro,
  customReportNameFetchList: [],
  customFieldObjectTypes: ["process"],
  columns: [
    {
      apiName: "ProcessTransactionNumber",
      label: "Process Transaction #",
      default: true,
    },
    { apiName: "Location", default: true },
    { apiName: "Date", default: true, date: true },
    { apiName: "Memo", label: "Comment" },
    { apiName: "Outputs", default: true },
    { apiName: "Input", default: true },
    { apiName: "Quantity", default: true, number: true },
    { apiName: "UOM" },
    { apiName: "AccountingCost", label: "Accounting Cost", number: true },
    { apiName: "Description", default: true },
    { apiName: "LineNumber", label: "Line Number", number: true },
    { apiName: "InputLot", label: "Input Lot" },
    { apiName: "InputBin", label: "Input Bin" },
    { apiName: "InputSerialNumbers", label: "Input Serials" },
    { apiName: "FromJob", label: "From Job" },
    { apiName: "Class" },
    { apiName: "WorkOrder", label: "Work Order" },
    { apiName: "Department" },
    { apiName: "StartDate", label: "Start Date" },
    { apiName: "Starred", number: true },
    { apiName: "Archived" },
  ],
  settings: [
    {
      apiName: "date1",
      macroApiName: "date1Macro",
      headerText: i18n("filter.heading.from"),
      component: "DateFilter",
      label: i18n("reports.FilterLabel.FromDate"),
      datePrefix: "startOf",
      defaultValue: () => new Date(),
      type: "filter",
    },
    {
      apiName: "date1Macro",
      component: SUB_COMPONENT,
      defaultValue: null,
      type: "filter",
    },
    {
      apiName: "date2",
      macroApiName: "date2Macro",
      component: "DateFilter",
      label: i18n("reports.FilterLabel.ToDate"),
      datePrefix: "endOf",
      defaultValue: () => new Date(),
      type: "filter",
    },
    {
      apiName: "date2Macro",
      defaultValue: null,
      component: SUB_COMPONENT,
      type: "filter",
    },
    {
      label: i18n("filter.Locations"),
      component: "LocationsFilter",
      apiName: "locations",
      defaultValue: null,
      placeholder: i18n("reports.placeholder.DefaultIsAll", {
        type: i18n("reports.locations"),
      }),
      type: "filter",
    },
    {
      label: i18n("reports.FilterLabel.Class"),
      component: "ClassFilter",
      apiName: "class",
      defaultValue: null,
      type: "filter",
    },
    {
      label: i18n("reports.FilterLabel.Department"),
      component: "DepartmentFilter",
      apiName: "department",
      defaultValue: null,
      type: "filter",
    },
    {
      label: i18n("reports.FilterLabel.OutputItemNameContains"),
      component: "FrmTextField",
      apiName: "nameContains2",
      defaultValue: null,
      type: "filter",
    },
    {
      label: i18n("reports.FilterLabel.InputItemNameContains"),
      component: "FrmTextField",
      apiName: "nameContains",
      defaultValue: null,
      type: "filter",
    },
    {
      apiName: "showArchived",
      defaultValue: false,
      label: i18n("reports.OptionLabel.IncludeArchivedTransactions"),
      component: "FrmCheckbox",
      type: "option",
    },
    {
      apiName: "showFromTo",
      defaultValue: false,
      label: i18n("reports.OptionLabel.ShowFromAndToDates"),
      component: "FrmCheckbox",
      type: "option",
    },
    {
      apiName: "header",
      defaultValue: "",
      label: i18n("global.Header"),
      component: "FrmTextField",
      type: "option",
    },
    {
      apiName: "footer",
      defaultValue: "",
      label: i18n("global.Footer"),
      component: "FrmTextField",
      type: "option",
    },
  ],
};
